// extracted by mini-css-extract-plugin
export default {"root":"Head_root__Db628","background":"Head_background__tf4wb","color":"Head_color__KQzb5","label":"Head_label__KgH5T","replica":"Head_replica__hiuJw"};